import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { UserRegistrationData } from '@app/pages/login/user-registration/user-registration.component';
import { CustomerInterestData } from '@app/shared/components/show-interest/show-interest.component';
import { EntityType } from '@app/shared/enums/enums';
import { Observable } from 'rxjs';

export interface ReportIssueData {
  entityType: EntityType;
  entityId: string;
  isInternalUser: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  constructor() {}

  http = inject(HttpClient);

  public postApiPublicReportIssue(data: ReportIssueData): Observable<any> {
    return this.http.post('/api/v1/public/report-issue', data);
  }

  public postApiPublicMessageUs(data: ReportIssueData): Observable<any> {
    return this.http.post('/api/v1/public/message-us', data);
  }

  public getEnums(enumNames: string[]): Observable<any> {
    let params = new HttpParams();
    for (const e of enumNames) {
      params = params.append('e', e);
    }
    return this.http.get('/api/v1/public/enums', {
      params: params,
    });
  }

  public postApiUserRegistration(data: UserRegistrationData): Observable<any> {
    return this.http.post('/api/v1/customer-user/new-user-registration', data);
  }

  public postApiCustomerInterestRegistration(data: CustomerInterestData): Observable<any> {
    return this.http.post('/api/v1/public/register-interest', data);
  }
}
